/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcheancePaiementListItemDto } from './EcheancePaiementListItemDto';
import {
    EcheancePaiementListItemDtoFromJSON,
    EcheancePaiementListItemDtoFromJSONTyped,
    EcheancePaiementListItemDtoToJSON,
    EcheancePaiementListItemDtoToJSONTyped,
} from './EcheancePaiementListItemDto';

/**
 * 
 * @export
 * @interface SearchEcheancesPaiementResponse
 */
export interface SearchEcheancesPaiementResponse {
    /**
     * Total number of payment schedules matching the search criteria
     * @type {number}
     * @memberof SearchEcheancesPaiementResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<EcheancePaiementListItemDto>}
     * @memberof SearchEcheancesPaiementResponse
     */
    items: Array<EcheancePaiementListItemDto>;
}

/**
 * Check if a given object implements the SearchEcheancesPaiementResponse interface.
 */
export function instanceOfSearchEcheancesPaiementResponse(value: object): value is SearchEcheancesPaiementResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchEcheancesPaiementResponseFromJSON(json: any): SearchEcheancesPaiementResponse {
    return SearchEcheancesPaiementResponseFromJSONTyped(json, false);
}

export function SearchEcheancesPaiementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchEcheancesPaiementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(EcheancePaiementListItemDtoFromJSON)),
    };
}

export function SearchEcheancesPaiementResponseToJSON(json: any): SearchEcheancesPaiementResponse {
    return SearchEcheancesPaiementResponseToJSONTyped(json, false);
}

export function SearchEcheancesPaiementResponseToJSONTyped(value?: SearchEcheancesPaiementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(EcheancePaiementListItemDtoToJSON)),
    };
}

